import UserInfo from './UserInfo.container';

export default UserInfo;